// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a08a09e9","769":"4d146c46"}[chunkId] + ".chunk.js";
};